<template>
  <div>
    <v-flex v-if="!isMobile" class="pfm-floating-panel" :class="{opened: isOpen && isWebapp, closed: !isOpen && !isWebapp, 'pfm-floating-panel': isWebapp, 'pfm-floating-panel-pfo': (!isWebapp && !isMobile)}"
    >
      <HeaderBar
              @close-panel2="closePanel2"
              @refresh="refreshSearchHB"
              :displayPerfumeDetails="displayPerfumeDetails"
              :isMobile="isMobile"
              @show-settings="showSettings"/>

      <v-flex pa-0 :style="{height: '100%'}">

        <v-layout column fill-height pa-0 class="pfo-layout-column">
          <v-layout row pa-0 fill-height :style="{flex: displayPerfumeDetails ? 0 : 'unset'}">
            <SearchElastic v-if="displayElasticSearch"
                           :is-disabled="isDisabled"
                           :is-loading="isLoading"
                           :isRTL="isRTL"
                           :locale="locale"
                           :country="country"
                           :isMobile="isMobile"
                           :is-first-search="isInitialSearch"
                           :isRefresh="isRefresh"
                           @set-display-details="displayDetails"
                           @set-favourite-se="setFavouriteSE" />
          </v-layout>
          <v-layout mainBlock row v-if="displayPerfumeDetails" pa-0>
            <v-layout xs6 fGrow column>
              <div class="sectionTitle">{{infoPerf}}</div>
              <v-flex pa-0 ma-2 elevation-0  class="carddetails" id="carddetails">
                <PerfumeDetails v-if="displayPerfumeDetails"
                            :perfFav="perfFav"
                            :perfDetails="perfDetails"
                            :perfFromUrl="perfFromUrl"
                            :locale="locale"
                            :country="country"
                            :isMobile="isMobile"
                            @set-favourite-det="setFavouriteDetails"
                />
              </v-flex>
            </v-layout>
            <v-layout xs6 fGrow column :style="{display: hideSuggestions === true ? 'none' : 'flex'}">
              <div class="sectionTitle">{{!displayFavouriteBadge ? ourselection : yourperf}}</div>
              <v-flex :xs0="!displayRightPanel"  pa-0 v-if="displayRightPanel" ma-2  class="carddetails cardRight">
                <MatchesList
                            :perfFav="perfFav"
                            :locale="locale"
                            :country="country"
                            :displayFavouriteBadge="displayFavouriteBadge"
                            @set-perfume-details="setPerfumesDetails"
                            @hide-sugg="hideSugg"
                />
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout row pa-0>
            <Settings v-if="displaySettings"
                      :locale.sync="locale"
                      :country.sync="country"
                      @set-settings="setSettings"
            />
          </v-layout>

      </v-layout>
      </v-flex>
    </v-flex>

    <v-flex v-else :style="panelPosition" :class="{'pfm-bottom-panel': isWebapp || this.$vuetify.breakpoint.xsOnly, 'pfm-floating-panel-pfo': !isWebapp && !this.$vuetify.breakpoint.xsOnly, opened: isOpen, closed: !isOpen}">

      <v-flex fixed color="#F2F2F2"
              height="100%"
              :style="{height: '100%'}"
                class="align-start"
              >
      <v-card pa-0 ma-0
            class="flex card-footer fill-height"
             color="#F2F2F2"
            flat>
        <v-card-text class="ma-0 pa-0">
        <HeaderBar @close-panel2="closePanel2"
                   @refresh="refreshSearchHB"
                  :isMobile="isMobile"
                    :displayPerfumeDetails="displayPerfumeDetails"
                   @show-elasticsearch="showElasticSearch"/>
        </v-card-text>

        <v-card-text class="ma-0 pa-0" :class="{'fill-height': !displayPerfumeDetails}" style="display: flex; flex-direction: column; flex: 1;">
          <v-container fluid pa-0 ma-0 :fill-height="!displayPerfumeDetails" style="flex: 1;">
            <v-layout column pa-0 style="height: 100%">


                    <v-flex class="xs12" pa-0 ma-0 :style="{height: '100%', display: 'flex', flexDirection: 'column'}" >
                    <SearchElastic
                        v-if="displayElasticSearch"
                        :is-disabled="isDisabled"
                        :is-loading="isLoading"
                        :isRTL="isRTL"
                        :locale="locale"
                        :country="country"
                        :isMobile="isMobile"
                        :is-first-search="isInitialSearch"
                        :isRefresh="isRefresh"
                        @set-display-details="displayDetails"
                        @set-favourite-se="setFavouriteSE"
                    />
                    <PerfumeDetailsMobile  v-if="displayPerfumeDetails"
                        :perfFav="perfFav"
                        :perfDetails="perfDetails"
                        :perfFromUrl="perfFromUrl"
                        :locale="locale"
                        :country="country"
                        :isMobile="isMobile"
                        @set-favourite-det="setFavouriteDetails"
                        @set-perfume-details="setPerfumesDetails"
                />
              </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>

              <v-flex v-if="displayPerfumeDetails && !hideSuggestions" :class="{'pfo-mt-1':displayPerfumeDetails}" class="ourselectionline font-weight-light body-1">
                <div class="ourSelection">{{this.ourselection}}</div>
              </v-flex>
        <v-card-text class="ma-0 pa-0 matchcard" v-if="displayPerfumeDetails">
          <MatchesListMobile :favourite="favourite"
                             :perfFav="perfFav"
                             :locale="locale"
                             :country="country"
                             :isRTL="isRTL"
                             :displayFavouriteBadge="!displayFavouriteBadge"
                             @hide-sugg="hideSugg"
                             @set-perfume-details="setPerfumesDetails" />
        </v-card-text>
      </v-card>
    </v-flex>
    </v-flex>
  </div>
</template>


<script>

import SearchElastic from "./SearchElastic"
import HeaderBar from "./HeaderBar"
import MatchesList from "./MatchesList"
import PerfumeDetails from "./PerfumeDetails"
import PerfumeDetailsMobile from "./PerfumeDetailsMobile"
import MatchesListMobile from "./MatchesListMobile"
import Settings from "@/components/Settings"


export default {
  name: "PanelPerfumist",
  components: {
    HeaderBar,
    SearchElastic,
    PerfumeDetails,
    PerfumeDetailsMobile,
    MatchesList,
    MatchesListMobile,
    Settings
  },
  data() {
    return {
      bottomDistance2: "8",
      fabPosition: "left: 20px",
      pfokey: "tbd",
      displayRightPanel: false,
      displayElasticSearch: true,
      displayPerfumeDetails: false,
      displayFavouriteBadge: false,
      displaySettings: false,
      favourite: "Votre favori",
      index: null,
      panel: false,
      descriptionLimit: 20,
      items: [],
      selected: [2],
      isLoading: false,
      isDisabled: false,
      isInitialSearch: true,
      isRefresh: true,
      dimg: true,
      model: null,
      keyword: null,
      keyword2: null,
      input: null,
      perfFav: {},
      perfDetails: {},
      perfMatch: {},
      perfFromUrl: false,
      footerHeight: "0px",
      panelPosition: process.env.VUE_APP_ISFABRIGHT == "true" ? "right: 25px; left: unset" : "left: 25px;",
      similars:[],
      hideSuggestions: true
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    isWebapp:  {
      type: Boolean,
      default: () => {
        return process.env.VUE_APP_IS_WEBAPP == 'true'
      }
    },
    locale: {
      type: String
    },
    country: {
      type: String
    },
    isRight: {
      type: Boolean,
      default: () => false
    },
    bottomDistance: {
      type: Number,
      default: () => 25,
    },
    isRTL: {
      type: Boolean,
      default: () => false
    },

  },
  computed: {
    ourselection () {
      if (this.locale==="en") return process.env.VUE_APP_SHOP_SUGGESTION_EN
      if (this.locale==="fr") return process.env.VUE_APP_SHOP_SUGGESTION_FR
      if (this.locale==="es") return process.env.VUE_APP_SHOP_SUGGESTION_ES
      if (this.locale==="de") return process.env.VUE_APP_SHOP_SUGGESTION_DE
      if (this.locale==="ja") return process.env.VUE_APP_SHOP_SUGGESTION_JP
      if (this.locale==="ar") return process.env.VUE_APP_SHOP_SUGGESTION_AR
      if (this.locale==="pt") return process.env.VUE_APP_SHOP_SUGGESTION_PT
      if (this.locale==="sv") return process.env.VUE_APP_SHOP_SUGGESTION_SV
      if (this.locale==="ru") return process.env.VUE_APP_SHOP_SUGGESTION_RU
      if (this.locale==="tr") return process.env.VUE_APP_SHOP_SUGGESTION_TR
      if (this.locale==="ms") return process.env.VUE_APP_SHOP_SUGGESTION_MS
      if (this.locale==="ko") return process.env.VUE_APP_SHOP_SUGGESTION_KO
      if (this.locale==="nl") return process.env.VUE_APP_SHOP_SUGGESTION_NL
      return process.env.VUE_APP_SHOP_SUGGESTION_EN
    },
    infoPerf () {
      if (this.locale==="en") return process.env.VUE_APP_INFO_PERF_EN
      if (this.locale==="fr") return process.env.VUE_APP_INFO_PERF_FR
      if (this.locale==="es") return process.env.VUE_APP_INFO_PERF_ES
      if (this.locale==="de") return process.env.VUE_APP_INFO_PERF_DE
      if (this.locale==="ja") return process.env.VUE_APP_INFO_PERF_JP
      if (this.locale==="ar") return process.env.VUE_APP_INFO_PERF_AR
      if (this.locale==="pt") return process.env.VUE_APP_INFO_PERF_PT
      if (this.locale==="sv") return process.env.VUE_APP_INFO_PERF_SV
      if (this.locale==="ru") return process.env.VUE_APP_INFO_PERF_RU
      if (this.locale==="tr") return process.env.VUE_APP_INFO_PERF_TR
      if (this.locale==="ms") return process.env.VUE_APP_INFO_PERF_MS
      if (this.locale==="ko") return process.env.VUE_APP_INFO_PERF_KO
      if (this.locale==="nl") return process.env.VUE_APP_INFO_PERF_NL
      return process.env.VUE_APP_INFO_PERF_EN
    },
    yourperf() {
        if (this.locale==="en") return process.env.VUE_APP_YOUR_PERFUME_EN
        if (this.locale==="fr") return process.env.VUE_APP_YOUR_PERFUME_FR
        if (this.locale==="es") return process.env.VUE_APP_YOUR_PERFUME_ES
        if (this.locale==="de") return process.env.VUE_APP_YOUR_PERFUME_DE
        if (this.locale==="ja") return process.env.VUE_APP_YOUR_PERFUME_JP
        if (this.locale==="ar") return process.env.VUE_APP_YOUR_PERFUME_AR
        if (this.locale==="pt") return process.env.VUE_APP_YOUR_PERFUME_PT
        if (this.locale==="sv") return process.env.VUE_APP_YOUR_PERFUME_SV
        if (this.locale==="ru") return process.env.VUE_APP_YOUR_PERFUME_RU
        if (this.locale==="tr") return process.env.VUE_APP_YOUR_PERFUME_TR
        if (this.locale==="ms") return process.env.VUE_APP_YOUR_PERFUME_MS
        if (this.locale==="ko") return process.env.VUE_APP_YOUR_PERFUME_KO
        if (this.locale==="nl") return process.env.VUE_APP_YOUR_PERFUME_NL
        return process.env.VUE_APP_YOUR_PERFUME_EN
      }
  },
  created() {
    this.bottomDistance2 = String(this.bottomDistance+82)

    if (this.isRight) { this.fabPosition = "right: "+process.env.VUE_APP_RIGHT_DISTANCE+"px" }
    else { this.fabPosition = "left: 35px" }

    this.footerHeight = String(Number(process.env.VUE_APP_FOOTER_HEIGHT)+400)+"px"

    if (process.env.VUE_APP_PFOKEY) {
      this.pfokey = process.env.VUE_APP_PFOKEY
    }
  },
  mounted() {

    if (typeof window._paq !== 'undefined') { window._paq.push(['trackEvent','PFO Widget','Display', 'Language: '+JSON.parse(localStorage.getItem('langPFO'))]) }

    let override_showbyurl = false
    if (JSON.parse(localStorage.getItem('pfo_display_clicked_match'))===true) {
      this.perfMatch = JSON.parse(localStorage.getItem('pfo_match'))
      if (this.perfMatch.id) {
        this.displayRightPanel = true
        this.isInitialSearch=false
        this.displayFavouriteBadge=true
        this.displayFromMatch(this.perfMatch)
        override_showbyurl = true
      }
      if (JSON.parse(localStorage.getItem('pfo_close_after_match'))===true) {
        this.isRefresh = false
        this.closePanel2()
        localStorage.setItem('pfo_close_after_match', JSON.stringify(false))
      }
    }

    if (override_showbyurl !== true) {
      let checkHomeUrls = process.env.VUE_APP_HOME_PATHNAMES.split(' ')
      if (!checkHomeUrls.includes(window.location.pathname) && (process.env.VUE_APP_SHOW_BY_URL === "true")) {
        if ((process.env.VUE_APP_CLOSE_AFTER_MATCH === "true")) {
          this.closePanel2()
        }
        let showurl = window.location.origin + window.location.pathname
        if (typeof process.env.VUE_APP_UNIVERSAL_URL !== 'undefined') {
          if (process.env.VUE_APP_UNIVERSAL_URL === "true") {
            let splittedurl = window.location.pathname.split('/')
            let checkLang = process.env.VUE_APP_LANGUAGES.split(' ')
            if (checkLang.includes(splittedurl[1])) {
              showurl = '/' + splittedurl.slice(2, splittedurl.length).join('/')
            } else {
              showurl = '/' + splittedurl.slice(1, splittedurl.length).join('/')
            }
          }
        }

        if (window.location.protocol === 'http:') {
          showurl = 'https:' + showurl.substring(5, showurl.length)
        }

        fetch(process.env.VUE_APP_API_BACKEND + '/api/show_by_url?url=' + showurl, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business " + this.pfokey,
            Accept: "version=2"
          }
        })
            .then(
                res => res.json(),
            )
            .then(res => {
              if (res.response != null) {
                this.isInitialSearch = false
                this.displayFavouriteBadge = false

                this.Message = "Fetching..."
                this.item = res.response

                if (JSON.parse(localStorage.getItem('pfo_display_clicked_match')) !== true) {

                  this.displayRightPanel = true
                  this.isInitialSearch = false
                  this.displayFavouriteBadge = false

                  localStorage.setItem('pfo_match', JSON.stringify(this.item))

                  this.displayFromUrl(this.item)
                }
              } else {
                this.displayRightPanel = false
                this.isInitialSearch = true
                this.isOpen = false
              }
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {
              this.isLoading = false
            })
      }
    }
  },
  methods: {
    trackEventDisplayMatomo() {
      setTimeout(function () {
        if (typeof window._paq !== 'undefined') {window._paq.push(['trackEvent', 'PFO Widget','Display', 'Language: '+JSON.parse(localStorage.getItem('langPFO'))])}
      }, 2000)
    },
    setFavourite: function () {
    },

    toggle (index) {
      const i = this.selected.indexOf(index)

      if (i > -1) {
        this.selected.splice(i, 1)
      } else {
        this.selected.push(index)
      }
    },
    /*closePanel() {
        this.$emit("closeParent")
    },*/
    closePanel2() {
      this.$emit("close-panel")
    },
    setFavouriteSE(favItem, isMobile) {
      this.perfFav=favItem
      console.log(this.perfFav)
      this.perfDetails=favItem
      localStorage.setItem('pfo_favourite', JSON.stringify(favItem))

      this.isInitialSearch = false
      if (!isMobile) { this.displayRightPanel=true } //!this.displayRightPanel
      this.displayPerfumeDetails = true
      this.isRefresh = false
      this.displayFavouriteBadge = false
    },
    setFavouriteDetails(favItem) {
      this.perfFav=favItem
      localStorage.setItem('pfo_favourite', JSON.stringify(favItem))
    },
    displayDetails(toDisplay) {
      this.displayPerfumeDetails=toDisplay
      this.displayRightPanel=toDisplay
      this.displaySettings = false
    },
    showElasticSearch() {
      this.displayElasticSearch=true
      this.displayRightPanel=false
      this.displayPerfumeDetails=false
      this.isInitialSearch = true
      this.isRefresh = true
      this.displaySettings = false
      localStorage.removeItem('pfo_favourite')
    },
    refreshSearchHB() {
      this.displayElasticSearch=true
      this.displayRightPanel=false
      this.displayPerfumeDetails=false
      this.isRefresh=true
      this.isInitialSearch=true
      this.displaySettings=false
      localStorage.removeItem('pfo_favourite')
    },
    showSettings() {
      this.displaySettings = true
      this.displayElasticSearch = false
      this.displayRightPanel = false
      this.displayPerfumeDetails = false
      this.isInitialSearch = false
    },
    setSettings() {
      this.$emit('set-settings')
    },
    setPerfumesDetails(currentperf, favperf, displayBadge) {
      this.perfDetails=currentperf
      this.perfFav=favperf
      this.displayFavouriteBadge = displayBadge
      this.isInitialSearch = false
      this.isRefresh = false
      this.displayPerfumeDetails = true
      this.displaySettings = false
    },
    hideSugg(val) {
      this.hideSuggestions = val
      console.log("hideSuggestions", this.hideSuggestions)
    },
    displayFromUrl(perf) {
      this.perfFromUrl = true
      this.perfDetails = perf
      this.perfFav = perf
      this.displayPerfumeDetails = true
      this.isInitialSearch = false
      this.isRefresh = false
      this.displayRightPanel = true
      this.displayFavouriteBadge = false
      this.displaySettings = false
    },
    displayFromMatch(perf) {
      this.perfFromUrl = true
      this.perfDetails = perf
      this.perfFav = JSON.parse(localStorage.getItem('pfo_favourite'))
      this.displayPerfumeDetails = true
      this.isInitialSearch = false
      this.isRefresh = false
      this.displayRightPanel = true
      this.displayFavouriteBadge = true
      this.displaySettings = false
      localStorage.setItem('pfo_display_clicked_match', JSON.stringify(false))
    },
    getPosition() {
      if (this.isRight) {
        return 'right: 20px'
      } else {
        return 'left: 20px'
      }
    },
    getBottomDistance() {
      return this.bottomDistance
    }
  }
}
</script>

<style>
.pfm-floating-panel {
  width: 100% !important;
  height: 100%;

  position: fixed;
  box-sizing: border-box;
  box-shadow: 0px 7px 40px 2px rgba(94, 94, 94, 0.3);
  background: #F2F2F2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.3s ease-in-out;
  border-radius: 8px;
  z-index: 2147483646; /*2147483647*/
}

.pfm-floating-panel-pfo {
  width: 400px !important;
  max-height: 775px;
  height: 80vh;
  position: fixed;
  left: 25px;
  bottom: 96px;
  box-sizing: border-box;
  box-shadow: 0px 7px 40px 2px rgba(94, 94, 94, 0.3);
  background: #F2F2F2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.3s ease-in-out;
  border-radius: 8px;
  z-index: 2147483646; /*2147483647*/
}

.pfm-floating-panel.closed {
  opacity: 0;
  visibility: hidden;
}

.closed {
  opacity: 0;
  visibility: hidden;
}
.pfm-bottom-panel {
  height: 100%;
  width: 100%;
  left: unset !important;
  right: unset !important;
  position: fixed;
  box-shadow: 0px 7px 40px 2px rgba(94, 94, 94, 0.3);
  background: #F2F2F2;
  display: flex;
  transition: 0.3s ease-in-out;
  border-radius: 8px;
  top: 0;
}
.pfm-bottom-panel.closed {
  opacity: 0;
  visibility: hidden;
}
.card-footer {
  padding: 0px;
  width: 100%;
  display: flex !important;
  flex-direction: column !important;
}
.card-height1 {
  height: 328px;
}
.matchcard {
  overflow-y: scroll;
}
.pfm-title {
  letter-spacing: 0;
  color: white;
}
.pfm-hg {
  height: 100%;
}
.pfm-favourite-list { 
  position:relative;
  width: 400px;
  height: 200px;
  overflow: auto;
}
.pfm-orders-layout { 
  top: 140px;
  bottom: 0;
  right: 0px;
  left: 400px;
  overflow: scroll;
}
.vperflayout {
  overflow-y: scroll;
}

.mainBlock {
  margin-top: 20px !important;
}
.horiz-scroll {
  overflow-y: hidden;
  overflow-x: scroll;
  padding-left: 4px;
  position: relative;
}

.vperflayout img {
}
.layout.row {
  margin: unset;
}
.hr {
  margin: unset;
}
.scroll2 {
  overflow: scroll;
  overflow-y: scroll;
}
.carddetails {
  border: thin #43454b;
  border-radius:15px;
  border-bottom-color: #43454b;
      background-color: white;
      height: 80vh;
      overflow: scroll;
}
  @media screen and (max-height: 900px) {
    .carddetails {
          height: 70vh;
    }

  }


.cardRight {
  background-color: transparent;
  border: none !important;
}
.withcard {
  border-radius:5px;
}
.ourselectionline {
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius:5px;
  margin-top: auto;
  flex: 0 !important;
}
.pfo-layout-column {
  width: 100%;
  align-items: unset;
  margin: 0px;
}
.pfo-mr-1 {
  margin-right: 4px;
}
.pfo-ml-1 {
  margin-left: 4px;
}
.pfo-mt-1 {
  margin-top: 4px;
}
.pfo-mt-0 {
  margin-top: 0px;
}
.pfo-mb-1 {
  margin-bottom: 4px;
}
.fGrow {
  flex-grow: 1 !important;
  flex-basis: 50% !important;
}
.sectionTitle {
  margin-left: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(30,30,30,0.7);
}

.ourSelection {
  margin-left: 5px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(30,30,30,0.7);
}
</style>